<template>
    <div>
        <ChangeLogModal
            ref="changelog"
            :primary-key="selectedKey"
            business-object="Translation"
            namespace="system"
        />
        <b-modal
            ref="translation-modal"
            cancel-variant="outline-secondary"
            ok-title="Save"
            @ok="onSave"
            size="lg"
            cancel-title="Close"
            centered
            title="Translations"
        >
            <b-form>
                <h5>{{ selectedKey }}:</h5>
                <b-form-group v-for="translation in translations">
                    <label for="email text-capitalize">{{ translation.language }}:</label>
                    <b-form-textarea
                        :name="translation.language"
                        type="text"
                        v-model="translation.translation"
                        rows="2"
                        max-rows="6"
                    />
                </b-form-group>
            </b-form>
            <template #modal-footer="data">
                <Button @click="$refs.changelog.show()">{{ $t('Component(Button):changelog') }}</Button>
                <Button @click="onSave">{{ $t('Component(Button):save') }}</Button>
                <Button @click="close">{{ $t('Component(Button):close') }}</Button>
            </template>
        </b-modal>
        <b-card :title="$t('Page(SystemTranslations):Component(Text):translation')">

            <!-- table -->
            <vue-good-table
                :columns="columns"
                :rows="rows"
                :rtl="direction"
                :search-options="{
                    enabled: true,
                    externalQuery: searchTerm }"
                :pagination-options="{
                    enabled: true,
                    perPage:pageLength,
                }"
                @on-row-click="onRowClick"
                styleClass="vgt-table bordered striped"
            >
                <template
                    slot="table-row"
                    slot-scope="props"
                >
                    <div
                        v-if="props.column.field === 'context.page'"
                        class="text-nowrap"
                    >
                        <span class="text-nowrap">{{ props.row.context.page || 'Any' }}</span>
                    </div>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'context.component'">
                        <span class="text-nowrap">{{ props.row.context.component || 'Any' }}</span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>

                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                    slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  Showing 1 to
                </span>
                            <b-form-select
                                v-model="pageLength"
                                :options="['5','10','15']"
                                class="mx-1"
                                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                            />
                            <span class="text-nowrap "> of {{ props.total }} entries </span>
                        </div>
                        <div>
                            <b-pagination
                                :value="1"
                                :total-rows="props.total"
                                :per-page="pageLength"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @input="(value)=>props.pageChanged({currentPage:value})"
                            >
                                <template #prev-text>
                                    <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                    />
                                </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-card>
    </div>
</template>

<script>
import {
    BForm, BFormTextarea, BCard, BModal, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {SystemApi} from '@core/api'
import {updateTranslation} from "@/libs/i18n";
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {ChangeLogApi} from "@core/api";
import Button from "@core/components/common/Button.vue";
import ChangeLogModal from "@core/components/common/changelog/ChangeLogModal.vue";

export default {
    components: {
        ChangeLogModal,
        Button,
        ToastificationContent,
        BFormTextarea,
        BModal,
        BForm,
        BCard,
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        Ripple,
    },
    name: "SystemTranslations",
    data() {
        return {
            pageLength: 10,
            direction: false,
            columns: [
                {
                    label: this.$t('Page(SystemTranslations):Component(Text):page'),
                    field: 'context.page',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Search Name',
                    },
                },
                {
                    label: this.$t('Page(SystemTranslations):Component(Text):type'),
                    field: 'context.component',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Search Component Type',
                    },
                },
                {
                    label: this.$t('Page(SystemTranslations):Component(Text):key'),
                    field: 'key',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Search Date',
                    },
                },
                {
                    label: this.$t('Page(SystemTranslations):Component(Text):translation'),
                    field: 'translation',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Translation text',
                    },
                },
            ],
            translations: [],
            selectedKey: '',
            rows: [],
            searchTerm: '',
        }
    },
    methods: {
        onRowClick(e) {
            SystemApi
                .localization
                .getTranslations(e.row.key)
                .then((r) => {
                    this.selectedKey = e.row.key;
                    this.translations = r.data;
                    this.$refs['translation-modal'].show();
                });
        },

        onSave() {
            let data = [];
            let engTranslation = '';
            this.translations.forEach((t) => {
                if (t.language === 'en') {
                    engTranslation = t.translation;
                }

                data.push({'translation': t.translation, 'language': t.language});
            });
            let key = this.selectedKey;

            SystemApi
                .localization
                .saveTranslations(key, {'translations': data, 'key': key})
                .then(() => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Translations has been successfully saved',
                            variant: 'success'
                        },
                    });

                    updateTranslation(key, data);

                    let element = this.rows.filter((row) => row.key === this.selectedKey);

                    if (element) {
                        element[0].translation = engTranslation;
                    }
                })
                .catch((e) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'BellIcon',
                            text: 'Unexpected error, please contact an administrator.',
                            variant: 'danger'
                        },
                    })
                })
                .finally(() => {
                    this.$refs['translation-modal'].hide();
                })
            ;
        },
        close() {
            this.$refs['translation-modal'].hide();
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                /* eslint-disable key-spacing */
                Current      : 'light-primary',
                Professional : 'light-success',
                Rejected     : 'light-danger',
                Resigned     : 'light-warning',
                Applied      : 'light-info',
                /* eslint-enable key-spacing */
            }

            return status => statusColor[status]
        }
    },
    created() {
        SystemApi.localization.getGrid().then((r) => {
            this.rows = r.data;
        })
    }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
